import React, { useEffect, useRef, useState } from "react";
import { userVisitNotiSocket } from "./stompService";
import { v4 as uuidv4 } from "uuid"; // npm install uuid

export const AdminNotification = () => {
  const [toastMessages, setToastMessages] = useState([]);
  const audioRef = useRef(null);

  useEffect(() => {
    userVisitNotiSocket((body) => {
      const id = uuidv4();

      const newMessage = {
        id,
        content: [
          `회원코드 ${body}님의 출석체크가 있습니다.`,
          <a
            href={`/user/${body}`}
            className="text-warning text-decoration-underline"
            key="link"
          >
            회원정보를 확인하시겠습니까?
          </a>,
        ],
      };

      setToastMessages((prev) => [...prev, newMessage]);
      audioRef.current?.play().catch((e) => console.warn("사운드 재생 실패", e));
    });

    audioRef.current = new Audio("/bf2.mp3");
  }, []);

  const handleClose = (id) => {
    setToastMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  return (
<div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1060 }}>
  {toastMessages.map((msg) => (
    <div
      key={msg.id}
      className="toast text-white bg-primary border-0 show mb-3 position-relative"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ minWidth: '320px' }}
    >
      {/* 닫기 버튼 - 우측 상단 */}
      <button
  type="button"
  className="btn-close btn-close-white position-absolute top-0 end-0 m-2"
  aria-label="Close"
  onClick={() => handleClose(msg.id)}
  style={{
    width: '1.5rem',
    height: '1.5rem',
    backgroundSize: '1.5rem',
  }}
></button>

      {/* 본문 */}
      <div className="toast-body fs-5 d-flex flex-column gap-2">
        {msg.content.map((line, idx) => (
          <div key={idx}>{line}</div>
        ))}
      </div>
    </div>
  ))}
</div>

  );
};



/*import React, { useEffect, useRef, useState } from "react";
import { connectWebSocket } from "./stompService";

export const AdminNotification = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState([]);
  const toastTimeout = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    connectWebSocket((body) => {
      setToastMessage([
        `회원코드 ${body}님의 출석체크가 있습니다.`,
        <a
          href={`/user/${body}`}
          className="text-warning text-decoration-underline"
          key="link"
        >
          회원정보를 확인하시겠습니까?
        </a>,
      ]);

      setShowToast(true);
      audioRef.current?.play().catch((e) => console.warn("사운드 재생 실패", e));

      if (toastTimeout.current) clearTimeout(toastTimeout.current);
      toastTimeout.current = setTimeout(() => setShowToast(false), 5000);
    });

    audioRef.current = new Audio("/bf2.mp3");

    return () => {
      if (toastTimeout.current) clearTimeout(toastTimeout.current);
    };
  }, []);

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1060 }}>
      <div
        className={`toast align-items-center text-white bg-primary border-0 ${showToast ? "show" : "hide"}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        onClick={() => setShowToast(false)}
      >
        <div className="d-flex flex-column gap-1 toast-body">
          {toastMessage.map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
          <button
            type="button"
            className="btn-close btn-close-white align-self-end mt-2"
            aria-label="Close"
            onClick={() => setShowToast(false)}
          ></button>
        </div>
      </div>
    </div>
  );
};
*/